import { createSlice } from "@reduxjs/toolkit";
import { userProfile } from "./thunk";
const userProfileSlice = createSlice({
  name: "user",
  initialState: {
    status: null,
    Profile: {},
  },
  extraReducers: {
    [userProfile.pending]: (state) => {
      state.status = "loading";
    },
    [userProfile.fulfilled]: (state, { payload }) => {
      console.log("payload 14", payload);
      state.status = "success";
      state.Profile = payload;
    },
    [userProfile.rejected]: (state, _error) => {
      state.status = "failed";
      state.Profile = {};
    },
  },
});

export default userProfileSlice.reducer;
